var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IOSSNumbersCreationSection',{attrs:{"IOSSNumber":_vm.IOSSNumber,"countries":_vm.countries},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }